import { render } from "./Authentification.vue?vue&type=template&id=baeca106&ts=true&lang=pug"
import script from "./Authentification.vue?vue&type=script&lang=ts"
export * from "./Authentification.vue?vue&type=script&lang=ts"

import "./Authentification.vue?vue&type=style&index=0&id=baeca106&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__